import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProfileLayout from "../global/ProfileLayout";

import { useTypedSelector } from "../../hooks/useTypedSelector";
import { SearchAndView } from "./components/SearchAndView";
import { NoData } from "../../components/NoData";
import { Collectible } from "./components/Collectible";

const Collections = () => {
  const { collectionWiseProfileNfts } = useTypedSelector(
    (state) => state.apiReducer
  );

  const [collections, setCollections] = useState(collectionWiseProfileNfts);
  const [searchVar, setSearchVar] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [filteredCollections, setFilteredCollections] = useState([]);

  useEffect(() => {
    setCollections(collectionWiseProfileNfts);
  }, [collectionWiseProfileNfts]);

  console.log("searched", searchVar, filteredCollections, collections);

  return (
    <ProfileLayout>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingBottom: "20px",
        }}
        gap="10px"
      >
        <SearchAndView
          searchVar={searchVar}
          setFiltered={(e) => {
            const { value } = e.target;
            setSearchVar(value);
            if (value === "") {
              setSearchShow(false);
              setFilteredCollections([]);
            } else {
              const filtered = collections.filter(
                (coll) =>
                  coll?.contractMetadata?.name &&
                  coll?.contractMetadata?.name
                    .toLowerCase()
                    .includes(value.toLowerCase())
              );

              setFilteredCollections(filtered);
              setSearchShow(true);
            }
          }}
        />

        <Box
          display="flex"
          flexDirection="column"
          width="97%"
          marginBottom="10px"
          marginTop="50px"
          alignItems={"center"}
          justifyContent={"center"}
          pl={1}
        >
          {searchShow && filteredCollections.length > 0 ? (
            filteredCollections.map((collection) => (
              <Collectible
                collectionName={collection.contractMetadata.name}
                collectionAddress={collection.address}
                totalNfts={collection.nfts.length}
                nfts={collection.nfts}
                setSearchVar={setSearchVar}
                setSearchShow={setSearchShow}
              />
            ))
          ) : searchShow && filteredCollections.length === 0 ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <NoData text="No Collections to show!" />
            </Box>
          ) : collections.length > 0 ? (
            collections.map((collection) => (
              <Collectible
                collectionName={collection.contractMetadata.name}
                collectionAddress={collection.address}
                totalNfts={collection.nfts.length}
                nfts={collection.nfts}
              />
            ))
          ) : (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <NoData text="No Collections to show!" />
            </Box>
          )}
        </Box>
      </Box>
    </ProfileLayout>
  );
};

export default Collections;
